export default __webpack_public_path__ + "static/media/fridge.b2743f4e.svg";